module.exports = __webpack_public_path__ + "static/media/16-strategiesforsurvivors.2db68b8f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/16-strategiesforsurvivors.pdf
// module id = 166
// module chunks = 0